<!--
CercleDigital InsiderGems, gestion électronique documentaire partagée de l'écosystème Cercle.
Copyright 2026 Pierre-Thibault Fabre <pierre-thibault@cercle.digital>
SPDX-License-Identifier: LicenseRef-Cercle-Interne

Fichier : apps/web/src/shell/Rouet.vue
Rôle : indicateur d'activité, monochrome et sobre.
Référence : designsystem.md.
-->
<script setup lang="ts">
withDefaults(
  defineProps<{
    taille?: number;
    /** Libellé lu par les lecteurs d'écran. */
    libelle?: string;
  }>(),
  { taille: 24, libelle: 'Opération en cours' },
);
</script>

<template>
  <svg
    class="rouet"
    :width="taille"
    :height="taille"
    viewBox="0 0 24 24"
    role="status"
    :aria-label="libelle"
  >
    <!-- Anneau de fond, puis arc tournant : la rotation seule porte le mouvement. -->
    <circle cx="12" cy="12" r="9" class="piste" />
    <circle cx="12" cy="12" r="9" class="arc" />
  </svg>
</template>

<style scoped>
.rouet { display: block; }

.piste {
  fill: none;
  stroke: var(--cig-encre);
  stroke-width: 2.4;
  opacity: 0.15;
}

.arc {
  fill: none;
  stroke: var(--cig-encre);
  stroke-width: 2.4;
  stroke-linecap: round;
  /* Un quart de circonférence : l'arc reste lisible à petite taille. */
  stroke-dasharray: 14 42;
  transform-origin: 50% 50%;
  animation: tourne 900ms linear infinite;
}

@keyframes tourne {
  to { transform: rotate(360deg); }
}

/*
 * Sans animation, l'arc reste visible et statique : l'indicateur garde son
 * sens, il cesse seulement de tourner.
 */
@media (prefers-reduced-motion: reduce) {
  .arc { animation: none; stroke-dasharray: 42 14; opacity: 0.5; }
}
</style>
